import { useFeatureFlag as harnessUseFeatureFlag } from '@harnessio/ff-react-client-sdk';

export default function useFeatureFlag(name: string, defaultValue?: any) {
  const featureFlag = harnessUseFeatureFlag(name, defaultValue);
  // useEffect(() => {
  //   if (!isNil(featureFlag)) {
  //     datadogRum.addFeatureFlagEvaluation(name, featureFlag);
  //   }
  // }, [featureFlag, name, defaultValue]);
  return featureFlag;
}
